import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const CareersPage = () => {
  const { theme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Careers | BookMyAudition</title>
      </Helmet>
      <div 
        className="careers-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Join Our Team
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Help us build the future of the entertainment industry. At BookMyAudition, we are always looking for passionate people who love cinema and technology.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="d-inline-block mb-3 px-3 py-1 rounded-pill" 
                  style={{ 
                    backgroundColor: 'rgba(59, 130, 246, 0.1)', 
                    color: '#3b82f6',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    border: '1px solid rgba(59, 130, 246, 0.2)'
                  }}
                >
                  WE ARE GROWING
                </div>
                <h3 className="fw-bold mb-3">No Openings Right Now</h3>
                <p className="mb-0 text-muted">
                  We don't have any immediate openings, but we are growing fast! Keep an eye on this page or send your CV to careers@bookmyaudition.com for future opportunities.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CareersPage;